import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import { PhoneCall, ShieldCheck, Gift } from 'lucide-react';
import Button from './Button';
import SuccessPopup from './SuccessPopup';
import 'react-phone-input-2/lib/style.css';
import metalBg from '../assets/images/metal-bg.jpg';

const FormSection = () => {
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || phone.length < 10) {
      setError('Пожалуйста, введите корректный номер');
      return;
    }

    setError('');

    try {
      const response = await fetch('/api/submit-form/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone }),
      });

      if (!response.ok) {
        throw new Error('Ошибка при отправке данных');
      }

      await response.json(); // можно использовать, если нужно
      setSuccessMessage('Успешно отправлено');
      setPhone('');
    } catch (error) {
      setError('Произошла ошибка при отправке формы');
      console.error(error);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  return (
    <section
      id="callback"
      className="relative h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url(${metalBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => setSuccessMessage('')}
        />
      )}

      <div className="absolute inset-0 bg-black opacity-50" />
      <div className="relative z-10 w-full max-w-3xl mx-auto bg-white/90 backdrop-blur p-10 rounded-3xl shadow-2xl space-y-8 animate-fade-in">
        <div className="text-center mb-6">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">Металлопрокат и арматура</h2>
          <p className="text-lg text-gray-700">
            Быстрая доставка, Лучшие цены, ГОСТ-сертификация, индивидуальный подход. Оставьте заявку — мы свяжемся в течение 30 секунд!
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
          <div className="flex flex-col items-center">
            <PhoneCall className="w-8 h-8 text-red-600 mb-2 transition-transform transform hover:scale-110" />
            <p className="text-sm">Ответим за 30 секунд</p>
          </div>
          <div className="flex flex-col items-center">
            <ShieldCheck className="w-8 h-8 text-green-600 mb-2 transition-transform transform hover:scale-110" />
            <p className="text-sm">ГОСТ и гарантия</p>
          </div>
          <div className="flex flex-col items-center">
            <Gift className="w-8 h-8 text-yellow-500 mb-2 transition-transform transform hover:scale-110" />
            <p className="text-sm">Скидка 10% новым клиентам</p>
          </div>
        </div>

        <form className="space-y-5 mt-4" onSubmit={handleSubmit}>
          <PhoneInput
            country={'ru'}
            value={phone}
            onChange={setPhone}
            inputProps={{
              name: 'phone',
              required: true,
              autoFocus: true,
            }}
            containerClass="w-full"
            inputStyle={{
              width: '100%',
              paddingLeft: '50px',
              paddingRight: '16px',
              paddingTop: '12px',
              paddingBottom: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '0.5rem',
              fontSize: '16px',
            }}
            buttonStyle={{
              border: 'none',
              background: 'transparent',
            }}
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <Button
            type="submit"
            className="w-full bg-gradient-to-r from-red-600 via-red-700 to-red-800 hover:bg-gradient-to-l text-white py-3 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg"
          >
            Оставить заявку
          </Button>

          <p className="text-xs text-center text-gray-500">
            Мы не передаём данные третьим лицам. Нажимая кнопку, вы соглашаетесь с{' '}
            <a href="/privacy" className="text-blue-600 hover:underline">политикой конфиденциальности</a>.
          </p>
        </form>
      </div>
    </section>
  );
};

export default FormSection;
